import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const taskEvidenceOutcomeBadgeStyleId = 'work-task-evidence-outcome-badge-theme';

export const taskEvidenceOutcomeBadgeBridgeStyles = {
  'task-evidence-outcome-badge': {
    '--local-outcome-badge-text': tokens.color.text.secondary,
    '--local-outcome-badge-bg': tokens.color.background.secondary,
    '--local-outcome-badge-border': tokens.color.border.secondary,
  },
  'task-evidence-outcome-badge.is-captured': {
    '--local-outcome-badge-text': tokens.color.text.successPrimary,
    '--local-outcome-badge-bg': tokens.color.background.successPrimary,
    '--local-outcome-badge-border': tokens.color.background.successSecondary,
  },
  'task-evidence-outcome-badge.is-exception': {
    '--local-outcome-badge-text': tokens.color.text.warningPrimary,
    '--local-outcome-badge-bg': tokens.color.background.warningPrimary,
    '--local-outcome-badge-border': tokens.color.background.warningSecondary,
  },
  'task-evidence-outcome-badge.is-outstanding': {
    '--local-outcome-badge-text': tokens.color.text.errorPrimary,
    '--local-outcome-badge-bg': tokens.color.background.errorPrimary,
    '--local-outcome-badge-border': tokens.color.border.errorSubtle,
  },
};
